<ng-container *ngIf="user$ | async as user">
  <div class="subtitle">
    <ng-container *ngIf="!open">
      Thanks, {{ user.firstName }}! We just sent you a verification link to your
      email and a 6-digit code to your phone (***) ***-{{
        user.phoneNumber.slice(-4)
      }}. Not your number?
      <span class="action-link" (click)="toggleOpen(true)">Update it</span>.
      Please verify both to continue.
    </ng-container>

    <ng-container *ngIf="open">
      Update your phone number.
      <!-- <span class="action-link" (click)="toggleOpen(false)">Click here</span> to
    cancel. -->
    </ng-container>
  </div>

  <app-verify-identity-update-phone
    *ngIf="open"
    [currentPhoneNumber]="user.phoneNumber"
    (handleClose)="toggleOpen(false)"
  ></app-verify-identity-update-phone>
</ng-container>
